import { useState, useMemo } from "react";

export default function Sortable(items = [], config = null) {
  const [sortedRecords, sortRecords] = useState(items);
  const [sortConfig, setSortConfig] = useState(config);

  const sortedItems = useMemo(() => {
    let sortableItems = [...sortedRecords];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [sortedRecords, sortConfig]);

  const sortIcon = (name) => {
    if (!sortConfig) {
      return;
    }
    if (sortConfig.key === name) {
      return sortConfig.direction === "ascending"
        ? "sort content ascending"
        : "sort content descending";
    }
    return undefined;
  };

  const sort = (key, direction = null) => {
    if (!direction) {
      direction = "ascending";

      if (
        sortConfig &&
        sortConfig.key === key &&
        sortConfig.direction === "ascending"
      ) {
        direction = "descending";
      }
    }
    setSortConfig({ key, direction });
  };

  return {
    sortedRecords: sortedItems,
    sortRecords,
    sort,
    sortConfig,
    sortIcon,
  };
}
